export default function useID() {
  let ns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return id => ns ? `${ns}-${id}` : id;
}